export default __webpack_public_path__ + "static/media/check-round-outline-16px.0de8803a.svg";